import React, { useState, useEffect } from 'react';
import { append } from '../i18n/i18n';
import { icons } from "../../assets/data/constants"
import qrPoster from "../../assets/images/elements/qr_payment_poster.pdf"

const Locale = () => {
  const [language, setLanguage] = useState(() => {
    const storedLanguage = localStorage.getItem('userLanguage');
    return storedLanguage || 'ua';
  });

  const [donateOpen, setDonateOpen] = useState(false);

  const changeLanguage = (newLanguage) => {
    setLanguage(newLanguage);
  };

  useEffect(() => {
    localStorage.setItem('userLanguage', language);
    append(require(`../../localization/${language}.json`));
  }, [language]);

  return (
    <div class="localeSign">
      <button
        className="donate-btn"
        onClick={() => setDonateOpen(true)}
        title="Пожертвування / Donate"
      >
        <img alt="Пожертвування" className='icon64 donate-icon' src={icons.pray}/>
      </button>

      {donateOpen && (
        <div className="donate-modal-overlay" onClick={() => setDonateOpen(false)}>
          <div className="donate-modal" onClick={e => e.stopPropagation()}>
            <button className="donate-modal-close" onClick={() => setDonateOpen(false)}>✕</button>
            <iframe
              src={qrPoster}
              title="QR Payment Poster"
              className="donate-modal-pdf"
            />
            <a
              href="https://myiban.com.ua/l/9qcqqc"
              target="_blank"
              rel="noopener noreferrer"
              className="donate-modal-link"
            >
              https://myiban.com.ua/l/9qcqqc
            </a>
          </div>
        </div>
      )}

      {language !== 'en' && (
        <button onClick={() => { changeLanguage('en'); window.location.reload();}}><img alt='' className='icon64' src={icons.flag_usa}/></button>
      )}
      {language !== 'ua' && (
        <button onClick={() => {changeLanguage('ua'); window.location.reload();}}><img alt='' className='icon64' src={icons.flag_ukraine}/></button>
      )}
    </div>
  );
};

export default Locale;
